import { render, staticRenderFns } from "./Softwareentwicklung.vue?vue&type=template&id=5ed38c14&scoped=true&"
import script from "./Softwareentwicklung.vue?vue&type=script&lang=js&"
export * from "./Softwareentwicklung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed38c14",
  null
  
)

export default component.exports